"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactstrap = require("reactstrap");
var _common = require("../../components/core/common");
var _core = require("../../services/core");
var _form = require("../../components/core/form");
var _sites = _interopRequireDefault(require("./components/sites"));
var _languages = _interopRequireDefault(require("./components/languages"));
var _autocomplete = _interopRequireDefault(require("./components/autocomplete"));
var _end = _interopRequireDefault(require("../main/end"));
var _community = require("../../services/community");
var _security = _interopRequireDefault(require("wever-core/dist/services/security"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// Style

// Core

const {
  Input,
  Radios
} = _form._Form;
const optionsStatus = [{
  label: (0, _core._translate)('common_private'),
  value: 'private'
}, {
  label: (0, _core._translate)('common_public'),
  value: 'public'
}, {
  label: (0, _core._translate)('common_other'),
  value: 'other'
}];
const optionsCivility = [{
  label: (0, _core._translate)('common_form_woman'),
  value: 'genre_femme'
}, {
  label: (0, _core._translate)('common_form_man'),
  value: 'genre_homme'
}, {
  label: (0, _core._translate)('common_form_response_gender_nsp'),
  value: 'genre_nsp'
}];

// Vue
const View = _ref => {
  let {
    community,
    loading,
    onSubmit,
    formLoading,
    disabled,
    displayHeader,
    childCommunityId,
    referencingId
  } = _ref;
  const communityId = community['_id'] || community['id'];
  const [loadingFc, setLoadingFc] = (0, _react.useState)(true);
  const [communityExist, setCommunityExist] = (0, _react.useState)(null);
  const [communityName, setCommunityName] = (0, _react.useState)(null);
  const isAuth = _security.default.isAuthenticated();
  const [defaultForm, setDefaultForm] = (0, _react.useState)({
    status: null,
    structure_name: null,
    community: `/communities/${communityId || 0}`
  });
  const loadData = () => {
    if (!referencingId) {
      setLoadingFc(false);
      return;
    }
    _core._Api.get('/structure_referencements/' + referencingId).then(res => {
      // res.data.activity = res.data.activity
      // res.data.structure = res.data.structure

      setDefaultForm(res.data);
      setLoadingFc(false);
    }).catch(err => {
      setLoadingFc(false);
    });
  };
  const loadColors = () => {
    const weverColor = community.colors?.primaryColor || 'red';
    const elements = document.querySelectorAll('.text-color-1');
    const btnElements = document.querySelectorAll('.btn-wever-red');
    const weverBorderColors = document.querySelectorAll('.wever-border-color');

    // Changer la couleur du texte pour chaque élément
    elements.forEach(element => {
      element.style.color = weverColor;
    });
    btnElements.forEach(element => {
      element.style.backgroundColor = weverColor;
    });
    if (weverBorderColors.length > 0) {
      for (const weverBorderColor of weverBorderColors) {
        weverBorderColor.style.borderColor = weverColor;
      }
    }
    if (document.querySelector('#description-referent')) {
      const text = document.querySelector('#description-referent').innerHTML;
      // Remplacer les premiers ** par <b>
      const boldText = text.replace('**', '<span class="fw-bold text-gray-1">');

      // Remplacer les derniers ** par </b>
      const finalText = boldText.replace('**', '</span>');

      // Mettre à jour le contenu HTML avec le texte modifié
      document.querySelector('#description-referent').innerHTML = finalText;
    }
  };
  const isCommunityAlreadyExist = async event => {
    const name = event.target?.value;
    setCommunityName(name);
    const exist = await (0, _community.isCommunityOnline)(name);
    setCommunityExist(exist);
  };
  (0, _react.useEffect)(() => {
    loadData();
  }, []);
  (0, _react.useEffect)(() => {
    if (loading || !community || loadingFc) {
      return;
    }
    loadColors();
  }, [community, loading, loadingFc, isAuth]);
  if (disabled) {
    return /*#__PURE__*/_react.default.createElement(_end.default, {
      media: community.logo
    });
  }
  if (loading || !communityId || loadingFc) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "w-100 d-flex justify-content-center"
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.Spinner, {
      color: "primary",
      size: "sm"
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "h-100 m-0 p-0 w-100 "
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    sm: 12,
    className: `p-0 m-0 container-header  py-2 bg-white header wever-border-color ${displayHeader ? '' : 'd-none'}`
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "p-0 m-0 "
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    xs: "5",
    sm: "3",
    md: "2",
    lg: "2",
    xl: "1"
  }, /*#__PURE__*/_react.default.createElement(_common._Media, {
    data: community.logo,
    className: "img-logo-register-club"
  })), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "d-flex align-items-center ",
    id: "title-register-club"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "fw-bold m-0"
  }, community.referencementTitle || (0, _core._translate)('structurereferencementapp_register_title'))), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "d-flex align-items-center justify-content-end"
  }, /*#__PURE__*/_react.default.createElement(_languages.default, null)))), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    sm: 12,
    className: "container-viewport d-flex align-items-start justify-content-center"
  }, !communityId ? (0, _core._translate)('structurereferencementapp_no_community_found') : /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: defaultForm,
    onSubmit: onSubmit
  }, formik => /*#__PURE__*/_react.default.createElement(_reactstrap.Form, {
    onSubmit: formik.handleSubmit
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-3 bg-white card mt-3 py-3"
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: "pl-2 fw-bold-force"
  }, (0, _core._translate)('structurereferencementapp_structure'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: " m-0 px-0 py-2"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-12 p-2 m-0"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-1 px-3 mb-2"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_community_ref'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7 fw-bold-force"
  }, community.name)), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-1 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_structure_type'), "* :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7"
  }, /*#__PURE__*/_react.default.createElement(_autocomplete.default, {
    name: "structure",
    url: "/structure_types",
    required: true
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-2 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_structure_name'), "* :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7"
  }, /*#__PURE__*/_react.default.createElement(Input, {
    name: "name",
    type: "text",
    label: null,
    required: true,
    onBlur: e => isCommunityAlreadyExist(e)
  }), true === communityExist && communityName && communityName !== '' && /*#__PURE__*/_react.default.createElement("span", {
    className: "text-danger"
  }, (0, _core._translate)('registerapp_club_company_organisation_exist')))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-1 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_siret'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7"
  }, /*#__PURE__*/_react.default.createElement(Input, {
    name: "siret",
    type: "text",
    label: null
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-2 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_status'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7 "
  }, /*#__PURE__*/_react.default.createElement(Radios, {
    name: "status",
    options: optionsStatus,
    label: null,
    groupProps: {
      className: 'input-radio'
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-1 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_activity_field'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7"
  }, /*#__PURE__*/_react.default.createElement(_autocomplete.default, {
    name: "activity",
    url: "/structure_activities"
  }), ' '))))), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), " ", /*#__PURE__*/_react.default.createElement("div", {
    className: " mt-4 bg-white card py-3"
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: "ml-3 pl-2 fw-bold-force"
  }, (0, _core._translate)('structurereferencementapp_mobility_reference'), " :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "m-0 px-0 py-2"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-12 p-2 m-0"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-1 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_civility'), "* :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7"
  }, /*#__PURE__*/_react.default.createElement(Radios, {
    name: "referent.civility",
    options: optionsCivility,
    label: null,
    groupProps: {
      className: 'input-radio'
    },
    required: true
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-1 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_civility_lastname'), "* :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7"
  }, /*#__PURE__*/_react.default.createElement(Input, {
    name: "referent.lastname",
    type: "text",
    label: null,
    required: true
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-2 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_civility_firstname'), "* :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7"
  }, /*#__PURE__*/_react.default.createElement(Input, {
    name: "referent.firstname",
    type: "text",
    label: null,
    required: true
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-1 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_civility_job'), "* :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7"
  }, /*#__PURE__*/_react.default.createElement(Input, {
    name: "referent.job",
    type: "text",
    label: null,
    required: true
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-2 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_civility_email'), "* :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7"
  }, /*#__PURE__*/_react.default.createElement(Input, {
    name: "referent.email",
    type: "email",
    label: null,
    required: true
  }))), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "py-1 px-3"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-4 col-md-5"
  }, (0, _core._translate)('structurereferencementapp_civility_phone'), "* :"), /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-7"
  }, /*#__PURE__*/_react.default.createElement(Input, {
    name: "referent.phone",
    type: "phone",
    label: null,
    required: true
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-5 bg-white card py-3"
  }, /*#__PURE__*/_react.default.createElement("h5", {
    className: "ml-3 pl-2 mb-0 fw-bold-force"
  }, (0, _core._translate)('structurereferencementapp_mobility_sites'), " :"), /*#__PURE__*/_react.default.createElement(_sites.default, null)), /*#__PURE__*/_react.default.createElement(_reactstrap.Row, {
    className: "mt-5"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Col, {
    className: "col-lg-11 col-md-12 d-flex justify-content-end mt-3 pr-4-5"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
    color: !disabled ? 'danger' : 'success',
    type: "submit",
    className: "btn-wever-red rounded-pill px-5 py-1 d-flex align-items-center fw-bold justify-content-center text-uppercase rounded-pill",
    disabled: formLoading || disabled || !isAuth && null === communityExist || true === communityExist
  }, ' ', /*#__PURE__*/_react.default.createElement(_common._Icon, {
    name: disabled ? 'check' : '',
    className: "mx-1"
  }), ' ', (0, _core._translate)(`structurereferencementapp_save${disabled ? 'd' : ''}`), ' ', formLoading && /*#__PURE__*/_react.default.createElement(_reactstrap.Spinner, {
    color: "default",
    size: "sm",
    className: "ml-1"
  }))))))));
};
var _default = exports.default = View;